module.exports = __webpack_public_path__ + "img/011-flamingo.9ef55da7.svg";